import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import * as firebase from 'firebase';
import { environment } from 'src/environments/environment';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { MainComponent } from './shared/components/main/main.component';
import { SideMenuComponent } from './shared/components/side-menu/side-menu.component';
import { TopBarComponent } from './shared/components/top-bar/top-bar.component';
import { AuthGuard } from './auth-guard';
import { FarmAppGuard } from './farm-app-guard';
import { WarehouseGuard } from './warehouse-guard';
import { SupplyDemandGuard } from './supply-demand-guard';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { ShowToastService } from './shared/services/show-toast.service';
import { LabAppGuard } from './lab-app-guard';
import { CookieService } from 'ngx-cookie-service';
// import { QRCodeModule } from 'angularx-qrcode';
firebase.initializeApp(environment.firebase);

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "#7e77c8",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": true,
  "fgsColor": "#7e77c8",
  "fgsPosition": "center-center",
  "fgsSize": 60,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 120,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.8)",
  "pbColor": "#7e77c8",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 300
};
@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    MainComponent,
    SideMenuComponent,
    TopBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
  ],
  providers: [AuthGuard,FarmAppGuard,WarehouseGuard,SupplyDemandGuard,ShowToastService,LabAppGuard,CookieService,
    {
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
